// Modal Wrapper component outlines the structure for the modal component.

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Drawer, Button, Popconfirm,
} from 'antd';
import DraggableModal from './DraggableModal';
import { makeSingleFlight } from '../../utils/singleFlight';

class ModalWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopConfirm: false,
    };
  }

  handleAction = makeSingleFlight((e) => {
    const { action } = this.props;
    if (!action) return undefined;
    return action(e);
  });

  showPopConfirm = () => {
    const { showConfirmation } = this.props;
    this.setState({ showPopConfirm: showConfirmation });
  };

  confirm = async () => {
    await this.setState({ showPopConfirm: false });

    return this.handleAction();
  };

  render() {
    const {
      customContentStyle,
      bodyStyle,
      modalTitle,
      dismiss,
      hideModal,
      actionName,
      disabled,
      children,
      form,
      isLoading,
      width,
      showConfirmation,
      isDrawer,
      isDraggable,
      closable,
      actionButtonDanger,
      handleClass,
      wrapClassName,
      footerNote,
      confirmationTitle,
    } = this.props;
    const { showPopConfirm } = this.state;

    let ModalComponent = Modal;

    if (isDrawer) {
      ModalComponent = Drawer;
    } else if (isDraggable) {
      ModalComponent = DraggableModal;
    }

    const modalProps = {
      visible: true,
      style: customContentStyle,
      bodyStyle,
      onClose: hideModal,
      width,
      title: modalTitle,
      onCancel: dismiss && hideModal,
      closable,
      maskStyle: { opacity: isDraggable && '0.5' },
      wrapClassName,
    };

    if (isDrawer) {
      modalProps.className = wrapClassName;
      delete modalProps.wrapClassName;
    }

    if (isDraggable) {
      modalProps.handleClass = handleClass;
    }

    return (
      <ModalComponent
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...modalProps}
        footer={[
          // Left-aligned "what's left" note (e.g. naming missing required fields).
          // margin-right:auto pushes the action buttons to the right in the
          // flex footer used by the chart modals.
          (footerNote
            && (
              <span key="note" className="modal-footer-note" style={{ marginRight: 'auto' }}>
                {footerNote}
              </span>
            )),
          (dismiss
            && (
              <Button onClick={hideModal} key="1">
                {dismiss}
              </Button>
            )),
          actionName && (
            <Popconfirm
              title={confirmationTitle}
              visible={showPopConfirm}
              onConfirm={this.confirm}
              onCancel={() => this.setState({ showPopConfirm: false })}
              key="2"
            >
              <Button
                type="primary"
                danger={actionButtonDanger}
                key="submit"
                form={form}
                htmlType="submit"
                disabled={disabled}
                loading={isLoading}
                onClick={showConfirmation ? this.showPopConfirm : this.handleAction}
              >
                {actionName}
              </Button>
            </Popconfirm>
          )]}
      >
        {children}
      </ModalComponent>
    );
  }
}

ModalWrapper.defaultProps = {
  action: null,
  actionName: null,
  handleClass: '.ant-modal-header',
  wrapClassName: '',
  dismiss: null,
  disabled: false,
  modalTitle: '',
  width: '520px',
  form: '',
  isLoading: false,
  showConfirmation: false,
  bodyStyle: {},
  isDrawer: false,
  isDraggable: false,
  closable: true,
  actionButtonDanger: false,
  footerNote: null,
  confirmationTitle: 'Editing existing labels will change them on the documents already tagged with this label. This may cause unintended mislabeling of previously labeled documents.',
};

ModalWrapper.propTypes = {
  customContentStyle: PropTypes.object.isRequired,
  bodyStyle: PropTypes.object,
  children: PropTypes.node.isRequired,
  hideModal: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  action: PropTypes.func,
  actionName: PropTypes.string,
  dismiss: PropTypes.string,
  disabled: PropTypes.bool,
  modalTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  form: PropTypes.string,
  isLoading: PropTypes.bool,
  showConfirmation: PropTypes.bool,
  isDrawer: PropTypes.bool,
  isDraggable: PropTypes.bool,
  closable: PropTypes.bool,
  actionButtonDanger: PropTypes.bool,
  handleClass: PropTypes.string,
  wrapClassName: PropTypes.string,
  footerNote: PropTypes.node,
  confirmationTitle: PropTypes.node,
};

export default ModalWrapper;
